import React from 'react';
import { ShieldCheck, Clock, Lock, Zap, FileText } from 'lucide-react';
import { Button } from './ui';
import { trackInitiateCheckout } from './useMetaPixel';
import { useCountdown } from '../hooks/useCountdown';
import { CHECKOUT_URL, costs, prices } from '../data/kit';
export function CostOfInaction() {
  const {
    units
  } = useCountdown({
    h: 23,
    m: 59,
    s: 52
  });
  return <section className="py-12 px-3 sm:px-4 bg-white" data-id="element-27" data-mp="34w03pq436sqa">
      <div className="max-w-5xl mx-auto mb-12" data-id="element-28" data-mp="34v8fj0ctjxa1">
        <h2 className="font-serif text-xl sm:text-2xl md:text-3xl font-bold text-wine text-center mb-5" data-id="element-29" data-mp="38xlkhmjqrr5r">
          ⚖️ ¿CUÁNTO TE CUESTA SEGUIR SIN SABER POR DÓNDE EMPEZAR?
        </h2>
        <div className="rounded-2xl border border-cream-400 overflow-hidden" data-id="element-30" data-mp="3dqo8zg9nwaf3">
          <table className="w-full text-left border-collapse table-fixed" data-id="element-31" data-mp="3imn0hcqae8jq">
            <colgroup data-id="element-32" data-mp="3nnsvxibc09wy">
              <col className="w-[48%]" data-id="element-33" data-mp="3nocen18t32c1" />
              <col className="w-[52%]" data-id="element-34" data-mp="3slcir6m3hv0i" />
            </colgroup>
            <thead data-id="element-35" data-mp="3sji05yyaqezl">
              <tr className="bg-cream-100 border-b border-cream-400" data-id="element-36" data-mp="3eggcgf30c4x9">
                <th className="px-3 sm:px-5 py-2.5 text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-ink-soft" data-id="element-37" data-mp="3ehrf2bkpv6ms">
                  Sin un sistema claro
                </th>
                <th className="px-3 sm:px-5 py-2.5 text-[11px] sm:text-xs font-bold uppercase tracking-wider text-rose-700 bg-rose-50" data-id="element-38" data-mp="34isd1bugi98r">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-300" data-id="element-39" data-mp="13e9vokeq59o">
              {costs.map(([problem, cost]) => <tr key={problem} data-id="element-40" data-mp="3nh4pp7kku193">
                  <td className="px-3 sm:px-5 py-3 text-[13px] sm:text-base text-ink-muted leading-snug" data-id="element-41" data-mp="3ngcsjsbbzvgp">
                    {problem}
                  </td>
                  <td className="px-3 sm:px-5 py-3 text-[13px] sm:text-base font-semibold text-wine leading-snug bg-rose-50/60" data-id="element-42" data-mp="3jdq666xfj2qw">
                    {cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-43" data-mp="299yjwxhz399d">
        <p className="font-serif text-xl md:text-2xl font-bold text-wine" data-id="element-44" data-mp="2e8jae57faekm">
          Tu próxima semana puede ser diferente.
        </p>
        <p className="font-serif text-xl md:text-2xl font-bold text-rose-600 mt-1" data-id="element-45" data-mp="1ziu4xxsaroej">
          Esta vez vas a saber por dónde empezar.
        </p>

        <p className="mt-9 flex items-center justify-center gap-2 font-bold text-wine text-base md:text-lg" data-id="element-46" data-mp="1qiyobdfz3174">
          <Clock className="w-5 h-5 text-rose-500" data-id="element-47" data-mp="1vibea7254odx" />
          EL PRECIO CIERRA EN:
        </p>
        <div className="mt-4 flex items-start justify-center gap-3 sm:gap-6" role="timer" data-id="element-48" data-mp="1gl12ewll5gho">
          {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-49" data-mp="1lkdohf4mujj7" data-mpi={i}>
              {i > 0 && <span className="text-rose-600 font-black text-4xl sm:text-5xl leading-none" aria-hidden="true" data-id="element-50" data-mp="3ay0mb1x00wur">
                  :
                </span>}
              <div className="text-center" data-id="element-51" data-mp="14a9roe759f74">
                <p className="tabular-nums font-black text-rose-600 text-5xl sm:text-6xl leading-none" data-id="element-52" data-mp="14bbf7i5cju5q">
                  {String(unit.value).padStart(2, '0')}
                </p>
                <p className="mt-2 text-[11px] font-semibold tracking-[0.3em] text-ink-soft" data-id="element-53" data-mp="1e0l5csgmr2r7">
                  {unit.label}
                </p>
              </div>
            </React.Fragment>)}
        </div>

        <div className="max-w-md mx-auto mt-8 rounded-3xl border-2 border-rose-500 bg-white p-5 sm:p-6 shadow-[0_24px_55px_-24px_rgba(148,64,76,0.6)]" data-id="element-54" data-mp="1mzq86az85i96">
          <h3 className="font-black text-wine text-lg sm:text-xl tracking-tight leading-tight" data-id="element-55" data-mp="1wyxiepanwws2">
            🌿 KIT MENOPAUSIA + PERIMENOPAUSIA
          </h3>
          <p className="text-sm text-rose-600 font-bold mt-1" data-id="element-56" data-mp="1s0dvalkc1ey4">5 Guías + 3 Bonos</p>
          <span className="inline-block mt-2 bg-wine text-white text-[9px] font-bold uppercase tracking-[0.18em] px-2.5 py-1 rounded-full" data-id="element-57" data-mp="2lz9a90p866b">
            Oferta de lanzamiento
          </span>
          <p className="text-xs font-semibold uppercase tracking-widest text-ink-soft mt-4" data-id="element-58" data-mp="3v962w6jmnefd">
            Antes <span className="line-through text-rose-600" data-id="element-59" data-mp="41adx3mt5sz5">{prices.before}</span>
          </p>
          <p className="text-5xl sm:text-6xl font-black text-wine leading-none tracking-tight mt-1" data-id="element-60" data-mp="90wrje6jtb8h">
            {prices.now}
          </p>
          <span className="inline-block mt-2.5 bg-sage-500 text-white text-[11px] font-bold uppercase tracking-wide px-3 py-1 rounded-full" data-id="element-61" data-mp="dzhtbi1g82z1">
            Ahorrás {prices.saving}
          </span>
          <p className="text-xs text-ink-muted mt-3" data-id="element-62" data-mp="3hhhqe25gunxv">✓ Pago único · ⚡ Acceso inmediato</p>
          <Button className="w-full mt-4 text-base py-4" onClick={() => {
          trackInitiateCheckout();
          window.location.href = CHECKOUT_URL;
        }} data-id="element-63" data-mp="3mfazb2y5lw1u">
            → QUIERO MI KIT POR {prices.now}
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-ink-muted mt-6" data-id="element-64" data-mp="2ypgoeqxeahk8">
          <span className="flex items-center" data-id="element-65" data-mp="1fu2ohvntzgx7">
            <Lock className="w-4 h-4 mr-1 text-ink-soft" data-id="element-66" data-mp="1btsjal7v4uje" /> Pago seguro
          </span>
          <span className="flex items-center" data-id="element-67" data-mp="1bro8djbjqv9m">
            <Zap className="w-4 h-4 mr-1 text-rose-500" data-id="element-68" data-mp="16twe4infix29" /> Acceso inmediato
          </span>
          <span className="flex items-center" data-id="element-69" data-mp="11w4et3kgg8o1">
            <ShieldCheck className="w-4 h-4 mr-1 text-sage-600" data-id="element-70" data-mp="11vcnw61syz43" /> Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-71" data-mp="wxt2mm6otm2n">
            <FileText className="w-4 h-4 mr-1 text-rose-500" data-id="element-72" data-mp="s59nhkscqivq" /> 100% digital
          </span>
        </div>
      </div>
    </section>;
}